import { Component } from '@angular/core';

@Component({
	selector: 'app-cookies-dialog',
	templateUrl: './cookies-dialog.component.html',
	styleUrls: ['./cookies-dialog.component.scss'],
})
export class CookiesDialogComponent {
	isShow = false;
	constructor() {}

	setCookie(name, value, days) {
		const expires = new Date();
		expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
	}

	getCookie(name) {
		const cookies = document.cookie.split(';');

		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i].trim();
			if (cookie.startsWith(name + '=')) {
				return cookie.substring(name.length + 1);
			}
		}
		return null;
	}

	deleteCookie(name) {
		document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
	}
}
